import { FEATURES } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";

export default function Features() {
  return (
    <section id="features" className="relative scroll-mt-20 overflow-hidden bg-background-100 py-16 md:py-24">
      <div className="pointer-events-none absolute -left-20 top-24 h-72 w-72 rounded-full bg-accent-100 blur-3xl"></div>
      <div className="pointer-events-none absolute -right-16 bottom-10 h-72 w-72 rounded-full bg-primary-100 blur-3xl"></div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-8">
        <Reveal>
          <SectionHeading
            kicker="玩法亮点"
            title={
              <>
                一场直播，<span className="text-accent-700">玩出百种互动</span>
              </>
            }
            desc="从围观到参与、从弹幕到打赏，每一种玩法都为了让「看热闹的你」真正成为现场的一部分。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURES.map((f, idx) => (
            <Reveal key={f.title} delay={(idx % 3) * 80}>
              <div className="group relative h-full overflow-hidden rounded-3xl border border-background-200 bg-background-50 p-6 transition hover:border-accent-300">
                <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-primary-500 to-accent-500 text-background-50 transition group-hover:scale-105">
                  <i className={`${f.icon} text-2xl`} />
                </div>
                <h3 className="mt-5 text-lg font-bold text-foreground-950">{f.title}</h3>
                <p className="mt-2.5 text-sm leading-6 text-foreground-600">{f.desc}</p>
                <span className="pointer-events-none absolute -right-4 -top-6 text-7xl font-black text-secondary-100 transition group-hover:text-accent-100">
                  {String(idx + 1).padStart(2, "0")}
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}